import React from "react";
import { IUserInfo } from "./models/IUserInfo";

export const UserInfoContext = React.createContext<IUserInfoContext>({
    userInfo: {} as IUserInfo,
});

export interface IUserInfoContext {
    userInfo: IUserInfo;
}